module.exports = __webpack_public_path__ + "static/hypnos_magen-4a993262e29447aa54e1cb2ac4ed2541.jpg";